var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vjs-matrix front img-raised rounded img-fluid w-100 colored-shadow"},[_c('video',{ref:"videoPlayer",staticClass:"video-js vjs-fluid"},[_c('source',{attrs:{"src":_vm.src,"type":"application/x-mpegURL"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }